<template>
  <div id='problem'>
    <h2>Prime Permutations</h2>
    <a href="https://projecteuler.net/problem=49">https://projecteuler.net/problem=49</a>
    <h3>Thoughts</h3>
    <p>
      Nice to get a problem with a well-defined upper bound. So long as we use a sieve to generate the set of primes (we
      can re-use the one from <a href="/projects/euler/7">problem 7</a> or any others), and write some isPermutation
      function properly, this one is pretty easy.
    </p>
  </div>
</template>

<script>

export default {
  name: 'P049Page',
  components: {
  },
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
